// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { themr } from "react-css-themr";
import { H, Page, Link } from "@lifepay/rc-ui-toolkit";
import { Switch, Route, Redirect } from "react-router-dom";
import { withRouter } from "react-router";

// ABSOLUTE PATH IMPORTS
import Emission from "../../Emission";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Emission.m.scss";

@withRouter
@themr("emission-page", styles)
export default class EmissionPage extends Component {
  static propTypes = {
    theme: PropTypes.object,
    match: PropTypes.object,
    basePath: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      pageHeader: "Эмиссия",
    };
  }

  setHeader = ({ pageHeader }) => {
    this.setState({ pageHeader });
  };

  render() {
    const { theme, match, basePath } = this.props;
    const { pageHeader } = this.state;
    return (
      <Page
        header={pageHeader}
        showHeader={false}
        breadcrumb={() => (
          <React.Fragment>
            <Link type="alt" to={`/`}>
              {"главная"}
            </Link>
            <div>{"->"}</div>
            <Link type="alt" to={`${basePath}/search`}>
              {"поиск клиента"}
            </Link>
            <div>{"->"}</div>
            <Link type="alt" to={`${basePath}/${match.params.clientId}/menu`}>
              {"выбор действия"}
            </Link>
            <div>{"->"}</div>
            <H t={"h4"}>{pageHeader}</H>
          </React.Fragment>
        )}
      >
        <div className={classnames(theme.wrapper)}>
          <div className={classnames(theme.content)}>
            <Switch>
              <Route
                path={`${match.path}/:subdir`}
                render={() => <Emission basePath={`${match.url}`} />}
              />
              <Route
                path="*"
                render={() => <Redirect to={`${match.url}/cards`} />}
              />
            </Switch>
          </div>
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/pages/Emission/Emission.js